import { DatePicker, Tag } from "antd";
import dayjs from "dayjs";
import SimpleTablePage from "../common/SimpleTablePage";
import DebounceSelect from "../common/DebounceSelect";
import { api } from "../common/api";
import { date2locale } from "../common/common";

const outcomes = {
  FIT: "Idoneo",
  FIT_WITH_RESTRICTIONS: "Idoneo con restrizioni",
  FIT_WITH_PRESCRIPTIONS: "Idoneo con prescrizioni",
  TEMPORARILY_UNFIT: "Non idoneo temporaneamente",
  PERMANENTLY_UNFIT: "Non idoneo permanente",
};

const columns = [
  {
    title: "Dipendente",
    key: "employee",
    dataIndex: "employee",
    render: (employee) => employee?.fullName,
    sorter: true,
    ellipsis: true,
    width: 250,
  },
  {
    title: "Giudizio d'idoneità",
    key: "medicalFitness",
    dataIndex: "medicalFitness",
    render: (fitness) =>
      fitness ? (outcomes[fitness.outcome] ?? fitness.outcome) : <Tag color="red">Mancante</Tag>,
    ellipsis: true,
    width: 250,
  },
  {
    title: "Data giudizio",
    key: "date",
    dataIndex: "date",
    render: (date) => (date ? date2locale(date) : "-"),
    sorter: true,
    width: 150,
  },
  {
    title: "Scadenza",
    key: "dueDate",
    dataIndex: "dueDate",
    render: (date) => (date ? date2locale(date) : "-"),
    sorter: true,
    width: 150,
  },
  {
    title: "Giorni di ritardo/rimasti",
    key: "daysLeft",
    dataIndex: "dueDate",
    render: (date) => {
      const days = date ? dayjs(date).diff(dayjs().startOf("day"), "day") : null;
      const color = days == null || days < 0 ? "red" : days < 30 ? "orange" : "blue";
      return <span style={{ color }}>{days ?? "MANCANTE"}</span>;
    },
    width: 200,
  },
];

const dateFilter = (name, label) => ({
  name,
  label,
  readableValue: date2locale,
  formItem: {
    props: {
      getValueProps: (value) => ({ value: value ? dayjs(value) : null }),
      normalize: (value) => value?.format("YYYY-MM-DD"),
    },
    children: <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />,
  },
});

const filterItems = [
  {
    name: "employee",
    label: "Dipendente",
    readableValue: (value) => value && JSON.parse(value).label,
    formItem: {
      props: {
        getValueProps: (value) => ({ value: value && JSON.parse(value) }),
        normalize: (value) => value && JSON.stringify(value),
      },
      children: (
        <DebounceSelect
          allowClear
          minSize={0}
          fetchOptions={(query) =>
            api.employee
              .list({ query, pageSize: 9999 })
              .then(({ data }) =>
                data.map((employee) => ({ label: employee.fullName, value: employee.id })),
              )
          }
        />
      ),
    },
  },
  dateFilter("startDate", "Data giudizio dal"),
  dateFilter("endDate", "Data giudizio al"),
  dateFilter("startDueDate", "Scadenza dal"),
  dateFilter("endDueDate", "Scadenza al"),
];

const fetchMedicalFitness = (params) =>
  api.employeeCurrentMedicalFitness.list({
    ...params,
    employee: params.employee ? JSON.parse(params.employee).value : undefined,
  });

export default function EmployeeCurrentMedicalFitness() {
  return (
    <SimpleTablePage
      title="Idoneità dei dipendenti"
      description="Consulta gli ultimi giudizi d'idoneità e le relative scadenze"
      resource="employeeCurrentMedicalFitness"
      columns={columns}
      filterItems={filterItems}
      fetchFunction={fetchMedicalFitness}
      rowKey={(record) => record.employee.id}
      searchQueryName={null}
      readOnly
    />
  );
}
